export default [
  {
    path:"/iframe",
    component: resolve => require(['@/components/iframe/Index'], resolve),
    children: [
      {
        path: 'histroyData/detail',
        component: resolve => require(['@/components/iframe/histroyDataMobile'], resolve),
      },
      {
        path: 'dataAnalysis/teamData',
        component: resolve => require(['@/components/iframe/TeamData'], resolve),
      },
      {
        path: 'dataAnalysis/playerData',
        component: resolve => require(['@/components/iframe/PlayerData'], resolve),
      },
      {
        path: 'matchSchedule/regularSeason',
        component: resolve =>
          require(['@/components/iframe/matchScheduleMobile/common/RegularSeason/RegularSeason'], resolve)
      },
      {
        path: 'matchSchedule/playOffs',
        component: resolve =>
          require(['@/components/iframe/matchScheduleMobile/common/playOffs/PlayOffs'], resolve)
      },
      {
        path: 'matchData/teamData',
        component: resolve =>
          require(['@/components/iframe/matchDataMobile/common/TeamData'], resolve)
      },
      {
        path: 'matchData/mapData',
        component: resolve =>
          require(['@/components/iframe/matchDataMobile/common/MapData'], resolve)
      },

      {
        path: 'matchData/mapData',
        component: resolve =>
          require(['@/components/iframe/matchDataMobile/common/MapData'], resolve)
      },
      // {
      //   path: 'cfs/teamScore',
      //   component: resolve =>
      //     // require(['@/components/iframe/matchDataMobile/common/teamScore/TeamRank'], resolve)
      //   require(['@/components/iframe/matchScheduleMobile/common/teamScore/TeamRank'], resolve)
      // },
      // {
      //   path: 'cfs/matchList',
      //   component: resolve =>
      //     // require(['@/components/iframe/matchDataMobile/common/teamScore/TeamRank'], resolve)
      //     require(['@/components/iframe/matchScheduleMobile/common/teamScore/Schedule'], resolve)
      // },
    ],
  },
  {
    path: "/oldiframe",
    component: resolve => require(['@/components/oldiframe/Index'], resolve),
    children: [
      {
        path: 'histroyData/detail',
        component: resolve => require(['@/components/oldiframe/histroyData'], resolve),
      },
      {
        path: 'dataAnalysis/teamData',
        component: resolve => require(['@/components/oldiframe/TeamData'], resolve),
      },
      {
        path: 'dataAnalysis/playerData',
        component: resolve => require(['@/components/oldiframe/PlayerData'], resolve),
      },
      {
        path: 'matchSchedule/regularSeason',
        // path: 'matchSchedule/playOffs',
        component: resolve =>
          require(['@/components/oldiframe/matchScheduleMobile/common/RegularSeason/RegularSeason'], resolve)
      },
      {
        path: 'matchSchedule/playOffs',
        // path: 'matchSchedule/regularSeason',
        component: resolve =>
          require(['@/components/oldiframe/matchScheduleMobile/common/playOffs/PlayOffs'], resolve)
      },
      {
        path: 'matchData/teamData',
        component: resolve =>
          require(['@/components/oldiframe/matchData/common/TeamData'], resolve)
      },
      {
        path: 'matchData/mapData',
        component: resolve =>
          require(['@/components/oldiframe/matchData/common/MapData'], resolve)
      },
      // {
      //   path: 'cfs/teamScorePC',
      //   component: resolve =>
      //     // require(['@/components/iframe/matchData/common/MapData'], resolve)
      //   require(['@/components/iframe/matchSchedule/common/teamScore/TeamRank'], resolve)
      // },
      // {
      //   path: 'cfs/matchListPC',
      //   component: resolve =>
      //     // require(['@/components/iframe/matchData/common/MapData'], resolve)
      //     require(['@/components/iframe/matchSchedule/common/teamScore/Schedule'], resolve)
      // }
    ],
  },
  {
    path: '/judge/login',
    component: resolve => require(['@/components/judge/JudgeLogin'], resolve),
    meta: {
      site: 'judge',
      judgeLogin: false,
      title: '裁判登录'
    }
  },
  {
    path: '/iframe/cfs/teamScore',
    component: resolve => require(['@/components/iframe/matchScheduleMobile/common/teamScore/TeamRank'], resolve),
  },
  {
    path: '/iframe/cfs/matchList',
    component: resolve => require(['@/components/iframe/matchScheduleMobile/common/teamScore/Schedule'], resolve),
  },
  {
    path: '/judge',
    component: resolve => require(['@/components/judge/Index'], resolve),
    meta: {
      site: 'judge',
      judgeLogin: false,
    },
    children: [{
      path: 'live_manager',
      component: resolve => require(['@/components/judge/LiveManager'], resolve),
      meta: {
        site: 'judge',
        judgeLogin: true,
        title: '直播控制'
      }
    }, {
      path: 'game_manager',
      component: resolve => require(['@/components/judge/GameManager'], resolve),
      meta: {
        site: 'judge',
        judgeLogin: true,
        title: '比赛管理'
      }
    }, ],
  },
  {
    path: '/tool/create_player_banner',
    component: resolve => require(['@/components/tool/CreatePlayerBanner'], resolve)
  },
  {
    path: '/milestone/milestone',
    component: resolve => require(['@/components/milestone/MileStone'], resolve),
    meta: {
      site: 'milestone',
      title: '里程碑'
    }
  },
]




// WEBPACK FOOTER //
// ./src/router/routerM.js